import { OverlayTrigger, Tooltip } from "react-bootstrap";

const BasicTooltip = ({ text, placement = "top", className = "", children, show = undefined }) => {
  return (
    <OverlayTrigger
      placement={placement}
      show={show}
      overlay={
        <Tooltip id={`tooltip-${Math.random().toString(36).substr(2, 9)}`} className={className}>
          {text}
        </Tooltip>
      }
      delay={{ show: 250, hide: 150 }}
    >
      {children}
    </OverlayTrigger>
  );
};

export default BasicTooltip;
